<template>
  <div class="box">
    <!-- 顶部图片 -->
    <div class="topBg">
      <div class="integral">我的积分:{{ integralNum }}分</div>
    </div>
    <!-- tabs切换 -->
    <van-tabs :active="type" sticky @change="CateIdClick">
      <van-tab
        v-for="item in tabList"
        :key="item.CateId"
        :title="item.Name"
        :name="item.CateId"
        color="#ff4500"
        background="#ff4500"
      >
      </van-tab>
    </van-tabs>
    <!-- 列表 -->
    <!-- 没有更多了 -->
    <van-empty v-if="!list.length" description="────── 暂无商品列表 ──────" />
    <div class="lists" v-else>
      <div
        class="list"
        v-for="item in list"
        :key="item.id"
        @click="gotoUrl('/integral/detail/' + item.GoodsId)"
      >
        <div class="listImg">
          <img :src="item.ImgUrl" style="width: 100%; height: 100%" />
        </div>
        <div class="listTitle">
          <span>{{ item.Name }}</span>
        </div>
        <div class="listLabel">
          <span>{{ item.Amount }}分/{{ item.MUnit }}</span>
          <span>{{ item.CateName }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  WxGetGoodsPage,
  WxGetGoodsSortList,
  WxGetGoodsCateList,
  WeGetMemberByOpenID,
} from "@/api/RealInfo";
import { getOpenId } from "@/utils/auth";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  data() {
    return {
      type: 20, //tabs选中
      tabList: [], //tabs类型
      list: [], //商品列表
      integralNum: 0,
    };
  },
  mounted() {
    this.getTabsList();
    this.getList();
    this.getMemberByOpenID();
  },
  methods: {
    // 切换分类
    CateIdClick(row) {
      console.log(row);
      this.type = row;
      this.getList();
    },
    // 获取不同分类列表
    getTabsList() {
      WxGetGoodsCateList({ shopType: 24 }).then((res) => {
        this.tabList = res.data.data;
      });
    },
    // 获取列表
    getList() {
      var cateId = this.type;
      WxGetGoodsPage({ shopId: 74, cateId: cateId }).then((res) => {
        console.log(res);
        this.list = res.data.data;
      });
    },
    // 获取会员信息
    getMemberByOpenID() {
      // getOpenId()
      WeGetMemberByOpenID({ openID: getOpenId() }).then((res) => {
        if (res.data.code == 0) {
          var data = res.data.data;
          this.integralNum =
            data.MeCurIntegral + data.PmCurIntegral + data.VolCurIntegral;
        } else {
          Toast.fail('您还不是会员,请先注册会员!');
        }
      });
    },
    // 跳转
    gotoUrl(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style scoped>
.box {
  background: #f7f8fa;
  height: 100%;
  min-height: 100vh;
}

/* 背景 */
.topBg {
  position: relative;
  height: 180px;
  width: 100%;
  background: url("../../assets/banner.jpg") no-repeat center;
  background-size: 100% 100%;
}

.topBg .integral {
  position: absolute;
  right: 0px;
  top: 10px;
  background: #ff4500;
  padding: 10px 22px;
  font-size: 12px;
  color: #fff;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
}

/* 列表 */
.lists {
  display: flex;
  justify-content: left;
  align-items: center;
}

.lists .list {
  width: 45%;
  margin-left: 3.5%;
  background: #fff;
  border-radius: 8px;
  margin-top: 10px;
}

.lists .listImg {
  width: 90%;
  height: 120px;
  text-align: center;
  margin: 13px 5%;
}

.listTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 0px 8px 8px;
}

.listTitle span:nth-child(1) {
  color: #01a5fd;
  font-weight: 700;
}

.listLabel span:nth-child(1) {
  color: #dd001b;
}

.listLabel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 0px 8px 8px;
}
</style>